import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard,
  Shield,
  Package,
  Truck,
  Users,
  MapPin,
  CreditCard,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Milk,
  BarChart3,
  AlertTriangle,
  Settings,
  Bell,
  FileText
} from 'lucide-react';
import '../../../assets/styles/admin/AdminSidebar.css';

const AdminSidebar = ({ isCollapsed, toggleSidebar }) => {
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('dashboard');

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
      path: '/admin/dashboard',
      color: '#3e96e7'
    },
    {
      id: 'subadmins',
      label: 'Sub-Admins',
      icon: Shield,
      path: '/admin/subadmins',
      color: '#6b7280'
    },
    // {
    //   id: 'suppliers',
    //   label: 'Suppliers',
    //   icon: Package,
    //   path: '/admin/suppliers',
    //   color: '#6b7280'
    // },
    {
      id: 'distributors',
      label: 'Distributors',
      icon: Truck,
      path: '/admin/distributors',
      color: '#6b7280'
    },
    // {
    //   id: 'customers',
    //   label: 'Customers',
    //   icon: Users,
    //   path: '/admin/customers',
    //   color: '#6b7280'
    // },
    {
      id: 'city-areas',
      label: 'City & Areas',
      icon: MapPin,
      path: '/admin/city-areas',
      color: '#6b7280'
    },
    {
      id: 'subscriptions',
      label: 'Subscriptions',
      icon: CreditCard,
      path: '/admin/subscriptions',
      color: '#6b7280'
    },
    
    {
      id: 'disputes',
      label: 'Disputes & Support',
      icon: AlertTriangle,
      path: '/admin/disputes',
      color: '#6b7280'
    },
    {
      id: 'blogs',
      label: 'Blog',
      icon: FileText,
      path: '/admin/blogs',
      color: '#6b7280'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: Bell,
      path: '/admin/notifications',
      color: '#6b7280'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      path: '/admin/settings',
      color: '#6b7280'
    }
  ];

  const handleMenuClick = (menuId) => {
    setActiveMenu(menuId);
  };

  const adminSignOut = () => {
    console.log("Sign out function called")
    // localStorage.removeItem("adminEmail");
    // localStorage.removeItem("adminPassword");
    // localStorage.removeItem("adminId");
    localStorage.removeItem("admin");
    navigate("/admin-login");
  }

  return (
    <div className={`adminmasterlayout-sidebar ${isCollapsed ? 'adminmasterlayout-sidebar-collapsed' : ''}`}>
      {/* Sidebar Header */}
      <div className="adminmasterlayout-sidebar-header">
        <div className="adminmasterlayout-logo-wrapper">
          <div className="adminmasterlayout-logo-icon">
            <Milk size={28} strokeWidth={2.5} />
          </div>
          {!isCollapsed && (
            <div className="adminmasterlayout-logo-text">
              <h2 className="adminmasterlayout-brand-name">MilkyWay Admin</h2>
            </div>
          )}
        </div>
      </div>

      {/* Sidebar Menu */}
      <nav className="adminmasterlayout-sidebar-nav">
        <ul className="adminmasterlayout-menu-list">
          {menuItems.map((item, index) => (
            <li 
              key={item.id} 
              className="adminmasterlayout-menu-item"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `adminmasterlayout-menu-link ${
                    isActive ? 'adminmasterlayout-menu-link-active' : ''
                  }`
                }
                onClick={() => handleMenuClick(item.id)}
              >
                <div className="adminmasterlayout-menu-icon-wrapper">
                  <item.icon 
                    className="adminmasterlayout-menu-icon" 
                    size={20} 
                    strokeWidth={2}
                  />
                </div>
                {!isCollapsed && (
                  <span className="adminmasterlayout-menu-label">{item.label}</span>
                )}
                {!isCollapsed && (
                  <div className="adminmasterlayout-menu-indicator"></div>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Sidebar Footer */}
      <div className="adminmasterlayout-sidebar-footer">
        {/* Sign Out Button */}
        <button className="adminmasterlayout-signout-btn">
          <div className="adminmasterlayout-signout-icon-wrapper">
            <LogOut 
              className="adminmasterlayout-signout-icon" 
              size={20} 
              strokeWidth={2}
            />
          </div>
          {!isCollapsed && (
            <span className="adminmasterlayout-signout-label" onClick={adminSignOut}>Sign Out</span>
          )}
        </button>

        {/* Collapse Button */}
        <button 
          className="adminmasterlayout-collapse-btn"
          onClick={toggleSidebar}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <div className="adminmasterlayout-collapse-icon-wrapper">
            {isCollapsed ? (
              <ChevronRight 
                className="adminmasterlayout-collapse-icon" 
                size={20} 
                strokeWidth={2}
              />
            ) : (
              <ChevronLeft 
                className="adminmasterlayout-collapse-icon" 
                size={20} 
                strokeWidth={2}
              />
            )}
          </div>
          {!isCollapsed && (
            <span className="adminmasterlayout-collapse-label">Collapse</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;